import React, { useState, useEffect } from "react";
import {
  Autocomplete,
  Card,
  Typography,
  TextField,
  Box,
  Popper,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Close, Search, ChevronRight } from "@mui/icons-material";
import { connect } from "react-redux";
import { homeActions } from "actions";
import { useHistory } from "react-router-dom";
import { handleProductSelect } from "./CommonFunctions";

const HomeAutoCompleteView = (props) => {
  const {
    productsSearchList,
    selectedProduct,
    customPopperView,
    getProductPartialSearch,
    selectedInsurance,
    saveSelectedProduct,
    resetData,
    changeView,
    zIndex,
    isFromHomeGauge,
    recentList,
    topProductsList,
    savedevicelocation,
    setCurrentLocation,
    organizationInfo,
  } = props;
  const history = useHistory();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const [searchValue, setSearchValue] = useState("");
  const [myOptions, setMyOptions] = useState([]);

  useEffect(() => {
    if (productsSearchList && productsSearchList.length) {
      const products = productsSearchList.map((option) => {
        return {
          groupTitle: "Select from below:",
          ...option,
        };
      });
      setMyOptions(products);
    }
  }, [productsSearchList]);

  useEffect(() => {
    updateInitialOptions();
  }, []);

  useEffect(() => {
    if (
      (recentList && recentList.length) ||
      (topProductsList && topProductsList.length)
    ) {
      updateInitialOptions();
    }
  }, [recentList, topProductsList]);

  const updateInitialOptions = () => {
    let result = [];

    const recent =
      recentList &&
      recentList.map((option) => {
        return {
          groupTitle: "Recent Searches:",
          ...option,
        };
      });
    let topProductsArr = topProductsList;

    // if (!topProductsList.length) {
    //   topProductsArr = topProducts;
    // }
    const top = topProductsArr?.map((option) => {
      return {
        groupTitle: "Top Searches:",
        ...option,
      };
    });
    result = [...recent, ...top];
    setMyOptions(result);
  };

  const productSearch = (event) => {
    setSearchValue(event.target.value);
    if (event?.target?.value && event.target.value.length > 2) {
      getProductPartialSearch(event.target.value);
    }
  };

  const getSelectedOption = (item) => {
    if (item) {
      const params = {
        item,
        selectedInsurance,
        saveSelectedProduct,
        resetData,
        history,
        changeView,
        isFromHomeGauge,
        savedevicelocation,
        setCurrentLocation,
      };
      handleProductSelect(params);
    }
  };

  const PopperView = (props) => {
    return (
      <Popper
        {...props}
        className="search-medication-popper-view"
        placement="bottom"
      />
    );
  };

  return (
    <Card
      id="search-container"
      className="search-container"
      sx={{
        zIndex: zIndex,
        width: matches ? "80vw" : undefined,
        marginLeft: matches ? 0 : undefined,
        left: matches ? "10vw" : undefined,
      }}
    >
      <Autocomplete
        autoHighlight
        value={selectedProduct}
        options={myOptions}
        groupBy={(option) => option.groupTitle}
        getOptionLabel={(option) =>
          option.productName || option.aliasName || ""
        }
        className="auto-complete-input"
        PopperComponent={customPopperView || PopperView}
        clearIcon={<Close fontSize="small" />}
        filterOptions={(all) => {
          return all;
        }}
        onChange={(event, newInputValue) => {
          getSelectedOption(newInputValue);
        }}
        // eslint-disable-next-line no-unused-vars
        renderOption={(props, option, { inputValue }) => {
          let optionName = "";
          const name = option.productName || option.aliasName;
          if (name) {
            const pattern = /inputValue/gi;
            optionName = name.replace(pattern, (match) => `<b>${match}</b>`);
          }
          return (
            <Box
              {...props}
              className="auto-complete-list-container"
              key={option.id}
              onClick={() => getSelectedOption(option)}
            >
              <Box
                {...props}
                className="search-list-view"
                dangerouslySetInnerHTML={{ __html: optionName }}
              ></Box>
              <ChevronRight className="right-icon" />
            </Box>
          );
        }}
        renderInput={(params) => (
          <Box>
            <Typography variant="h3LatoBold" sx={{ letterSpacing: "0.09px" }}>
              Enter a medication:
            </Typography>
            <Box sx={{ position: "relative" }} mt={1}>
              <TextField
                {...params}
                variant="standard"
                value={searchValue}
                onChange={productSearch}
              />
              <Search
                sx={{
                  color: `${organizationInfo?.colorSchemeJson?.primaryButtonColor} !important`,
                }}
                className="search-icon"
              />
            </Box>
          </Box>
        )}
      />
    </Card>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedProduct: state.home.selectedProduct,
    selectedInsurance: state.insuranceList.selectedInsurance,
    productsSearchList: state.productSearchList.data,
    recentList: state.recentSearch.data,
    topProductsList: state.topProducts.data || [],
    organizationInfo: state.organizationInfo.data || {},
  };
};

const mapDispatchToProps = {
  getProductPartialSearch: (value) =>
    homeActions.getProductPartialSearch(value),
  saveSelectedProduct: (value) => homeActions.saveSelectedProduct(value),
  resetData: (value) => homeActions.resetData(value),
  savedevicelocation: (value) => homeActions.savedevicelocation(value),
  setCurrentLocation: (value) => homeActions.setCurrentLocation(value),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomeAutoCompleteView);
